<template>
  <div>
    <div class="relative mb-5">
      <div>
        <img src="../../assets/mobile/you.png" class="max-full-width" />
      </div>
      <div
        class="absolute display-flex align-center justify-space-between profile__header"
      >
        <img
          src="../../assets/mobile/icon/dot.svg"
          width="27"
          @click="$router.push({ name: 'PlanMobile' })"
        />
        <img
          src="../../assets/mobile/icon/arrow-down-white.svg"
          width="27"
          @click="$router.push({ name: 'CommunityMobile' })"
        />
      </div>
      <div class="absolute profile__username">
        <img src="../../assets/mobile/profile.png" class="max-full-width" />
        <div class="profile__username__name">
          <span> Salva </span>
          <img
            src="../../assets/mobile/icon/check-circle.svg"
            class="max-full-width"
          />
        </div>
        <div class="profile__username__type">@salva • 423.2k Followers</div>
      </div>
    </div>

    <div class="display-flex align-center full-width my-3 px-4">
      <v-btn class="profile__btn" @click="$router.push({ name: 'PlanMobile' })">
        Follow
      </v-btn>
      <v-btn
        @click="$router.push({ name: 'ChatRoomMobile' })"
        class="profile__btn"
      >
        Chat live!
      </v-btn>
    </div>

    <div class="horizontal-scroll my-4 px-4">
      <div
        v-for="(item, index) in categoryList"
        :key="index"
        class="profile__category horizontal-scroll__item display-flex justify-center align-center mr-2 px-4"
        :class="{ 'bg-white text-black': item.active }"
      >
        {{ item.text }}
      </div>
    </div>

    <div class="text-poppins-16 font-weight-700 mt-2 px-4">Albums</div>
    <div class="horizontal-scroll px-4">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_3.jpg"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Album</div>
        <div class="text-grey-4 font-15 font-weight-500">Artist name</div>
      </div>
    </div>

    <div class="display-flex justify-space-between align-center mt-2 px-4">
      <div class="text-poppins-16 font-weight-700">Products</div>
      <div class="see-all font-weight-500">See All</div>
    </div>
    <div class="horizontal-scroll px-4">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_5.png"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Album</div>
        <div class="text-grey-4 font-15 font-weight-500">Artist name</div>
      </div>
    </div>

    <div class="display-flex justify-space-between align-center mt-2 px-4">
      <div class="text-poppins-16 font-weight-700">Playlists</div>
      <div class="see-all font-weight-500">See All</div>
    </div>
    <div class="horizontal-scroll px-4">
      <div v-for="i in 5" :key="i" class="horizontal-scroll__item mr-2 mb-2">
        <div>
          <img
            src="../../assets/mobile/library_6.jpg"
            width="151"
            height="151"
          />
        </div>
        <div class="font-15 font-weight-500 text-white">Album</div>
        <div class="text-grey-4 font-15 font-weight-500">Artist name</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      categoryList: [
        {
          text: "Free",
          active: true,
        },
        {
          text: "Loud Pack",
          active: false,
        },
        {
          text: "Gold",
          active: false,
        },
        {
          text: "Platinum",
          active: false,
        },
        {
          text: "Sample packs",
          active: false,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
.profile {
  &__header {
    top: 0px;
    width: 100%;
    padding: 24px;
  }
  &__username {
    font-style: normal;
    font-weight: 500;
    line-height: 27px;
    bottom: -40px;
    left: 22px;
    &__name {
      color: #fff;
      font-size: 24px;
      letter-spacing: -0.48px;
    }
    &__type {
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      line-height: 120%;
    }
  }
  &__category {
    border-radius: 100px;
    border: 1px solid rgba(255, 255, 255, 0.4);
    color: rgba(255, 255, 255, 0.9);
    font-size: 13px;
    font-weight: 500;
    line-height: 150%;
    height: 28px;
  }
  &__btn {
    background: #593eff !important;
    height: 40px;
    width: 50%;
    border-radius: 6px;
    color: #fff;
    font-size: 16px;
    font-weight: 500;
    line-height: 150%;
  }
}

.see-all {
  color: #a0a1b0;
  font-size: 16px;
  letter-spacing: -0.16px;
}
</style>



// WEBPACK FOOTER //
// profile.vue?50076338